import { ErrorBoundary, HomeWidget, componentError, api, PortalContext } from "@portal/arq-portal-core"
import React from "react"
import { MuroCompleto } from "./MuroCompleto"

export const WrappedMuroCompleto = (props:any) => {    
    const [currentUser, setCurrentUser] = React.useState();
    const [selectedCom, setSelectedCom] = React.useState();
    const { ciaGestiona } = React.useContext(PortalContext);

    var urlParams = new URLSearchParams(window.location.search);
    var ciaUrl = urlParams.get('cia');
    let cia = (ciaUrl === 'SCO' || ciaUrl === 'SBI' || ciaUrl === 'SPU') ? ciaUrl : ciaGestiona;

    const [initialize, setInitialize] = React.useState(false)
    const [currentUserLoading, setCurrentUserLoading] = React.useState(false);

    if(!currentUserLoading){
        setCurrentUserLoading(true);
        api.post('/be/piupointgetuserbyuserlogin/',{"Entrada":{"cia": cia,"isMockup":false}}).then((userdata) => {
            setCurrentUser(userdata?.Salida?.response?JSON.parse(userdata.Salida.response)[0] : {});
            setSelectedCom(userdata?.Salida?.response?JSON.parse(userdata.Salida.response)[0]["Communities"][0]?.CommunityId : null);        
            setInitialize(true);
        });
    }

    return (
        <ErrorBoundary 
            fallback={()=>{
                return <HomeWidget titulo={componentError.title} error={componentError.body}></HomeWidget>
            }}
        >
                {initialize && <MuroCompleto {...props} currentUser={currentUser} communityId={selectedCom}/>}
        </ErrorBoundary>
    )
}